import { useState } from 'react'
import DefaultLayout from '../../../../components/DefaultLayout'
import styled from 'styled-components'
import { useUserProfile } from '../../hooks/useUserProfile'
import { GeneralTab } from '../../components/GeneralTab'
import { ITabs, TabButton, TabValueTypes } from '../../components/TabButton'
import { PrivacyTab } from '../../components/PrivacyTab'
import { SecurityTab } from '../../components/SecurityTab'
import { NotificationsTab } from '../../components/NotificationsTab'

const TABS: ITabs[] = [
    { name: 'Общее', value: 'general' },
    { name: 'Безопасность', value: 'secure' },
    { name: 'Приватность', value: 'privacy' },
    { name: 'Уведомления', value: 'notifications' },
]

const TabItem: Record<TabValueTypes, JSX.Element> = {
    general: <GeneralTab />,
    privacy: <PrivacyTab />,
    secure: <SecurityTab />,
    notifications: <NotificationsTab />,
}

const UserProfile = () => {
    const [currentTab, setCurrentTab] = useState<ITabs>({
        name: 'Общее',
        value: 'general',
    })

    const { user } = useUserProfile()

    const username =
        user &&
        `${user.user_metadata.first_name} ${user.user_metadata.second_name}`

    return (
        <>
            <Heading>
                <div className="container">
                    <Ava></Ava>
                </div>
            </Heading>
            <Content>
                <Wrapper className="container">
                    <Info>
                        <Name>{username}</Name>
                        <Role>Seller</Role>

                        <SettingsChooser>
                            {TABS.map((i, idx) => (
                                <TabButton
                                    tab={i}
                                    key={idx}
                                    setCurrentTab={setCurrentTab}
                                    currentTab={currentTab}
                                />
                            ))}
                        </SettingsChooser>
                    </Info>
                    <Tab>
                        <TabHead>{currentTab.name}</TabHead>
                        <TabContent>
                            <TabContainer>
                                {TabItem[currentTab.value]}
                            </TabContainer>
                        </TabContent>
                    </Tab>
                </Wrapper>
            </Content>
        </>
    )
}

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 200px 1fr;
    grid-gap: 100px;
    padding-top: 60px;
    padding-bottom: 100px;
`

const Heading = styled.div`
    height: 300px;
    width: 100%;
    background-color: #f0ebe6;

    .container {
        position: relative;
        height: 100%;
    }
`

const Ava = styled.div`
    display: block;
    width: 100px;
    height: 100px;
    position: absolute;
    bottom: -30px;
    left: 100px;
    transform: translateX(-50%);
    border-radius: 50%;
    /* background: #ccc7c2; */
    background: url('/images/primary/avatar.jpeg') no-repeat;
    background-size: cover;
    background-position: center center;
`

const Info = styled.div`
    background: #fff;
    min-height: 50vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const Tab = styled.div``

const Content = styled.div``

const Name = styled.h1`
    font-size: 16px;
    font-weight: 600;
    color: #333;
`

const Role = styled.p`
    font-size: 17px;
    color: #747474;
`

const TabHead = styled.div`
    background: #fafbfc;
    color: #000;
    border-radius: 4px 4px 0 0;
    font-weight: 500;
    font-size: 16px;
    padding: 0 20px;
    height: 64px;
    display: flex;
    align-items: center;
`

const TabContent = styled.div`
    background: #fff;
    /* border: 1px solid #5757571a; */
    padding: 0 20px;
    border-radius: 0 0 4px 4px;
    .card {
        display: flex;
        padding: 15px 0;
        &:not(:last-child) {
            border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        }

        &:last-child {
            border-radius: 7px;
        }
    }
    p {
        color: #000;
        font-size: 13px;
        width: 230px;
    }
    span {
        color: #000;
        font-size: 13px;
    }
`

const SettingsChooser = styled.div`
    padding: 6px 0;
    background: #fff;
    border: 1px solid #5757571a;
    width: 100%;
    margin-top: 15px;
    border-radius: 5px;

    .card {
        padding: 5px 0;
        cursor: pointer;
        color: grey;
        font-size: 13px;
        padding-left: 20px;
        font-weight: 500;
        transition: 0.23s all ease;
        border-left: 2px solid transparent;
        &:nth-child(n + 2) {
            margin-top: 5px;
        }
    }
    .active {
        border-left: 2px solid #ff29cb !important;
        color: #000;
        background: #f2f3f5;
    }
`

const TabContainer = styled.div`
    display: flex;
`

export default UserProfile
